import { Baby, AlertTriangle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { pregnancyAlerts } from "@/lib/clinic";

export default function PregnancyAlerts({ onPatient }) {
  const { t, view } = useApp();
  const alerts = pregnancyAlerts(view);
  if (!alerts.length) return null;
  return (
    <div className="rounded border border-[#B5177A]/40 bg-[#FDF2F8] p-3" data-testid="pregnancy-alerts">
      <div className="font-bold text-sm text-[#B5177A] flex items-center gap-1 mb-2"><Baby className="w-4 h-4" />{t("pregnancy_alerts")} ({alerts.length})</div>
      <div className="space-y-1">
        {alerts.map(({ p, preg, last, deliveryDue, visitDue, overdue }) => (
          <button key={p.id} type="button" onClick={() => onPatient(p)} className="w-full text-start rounded border border-[#E5E5E5] bg-white px-3 py-2 text-sm flex flex-wrap items-center gap-2 hover:bg-[#FCE7F3]" data-testid="pregnancy-alert-row">
            <span className="font-bold">{p.name}</span>
            {preg?.weeks != null && <span className="text-xs text-[#555]" dir="ltr">{preg.weeks}+{preg.days} {t("weeks_short")}</span>}
            {deliveryDue && <span className={`px-2 py-0.5 rounded text-white text-xs font-bold ${overdue ? "bg-[#C7353B]" : "bg-[#B5177A]"}`} data-testid="alert-delivery">{overdue ? t("delivery_overdue") : t("delivery_due")} · {preg.edd}</span>}
            {visitDue && <span className="px-2 py-0.5 rounded bg-[#E67E22] text-white text-xs font-bold flex items-center gap-1" data-testid="alert-visit"><AlertTriangle className="w-3 h-3" />{t("prenatal_due")}{last ? ` · ${t("last_visit")} ${last}` : ""}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
